// import React, { useEffect, useState } from 'react';
// import '../Styles/PopupContactForm.css';
// import axios from "axios";

// import {
//   getCampaignId,
//   getConversionLabel,
//   gtag_report_conversion,
// } from './ConversionHandler';

// const PopupContactForm = ({ showPopup, setShowPopup }) => {
//   const campaignId = getCampaignId();

//   const [formData, setFormData] = useState({
//     name: '',
//     number: '',
//     email: '',
//     message: ''
//   });

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowPopup(true);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, [setShowPopup]);

//   if (!showPopup) return null;

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const label = getConversionLabel('form', campaignId);
//     console.log('📨 Popup form submitted - Conversion Label:', label);

//     // ✅ Send form data to backend
//     try {
//       const response = await axios.post('https://krushika.org/crm/endpoint.php', formData);
//       console.log('Form submitted successfully', response.data);
//     } catch (error) {
//       console.error('Error submitting form', error);
//     }

//     const callback = () => {
//       console.log('✅ Popup form conversion recorded');
//       alert('Thank you! We’ve received your message.');
//       setShowPopup(false);
//     };

//     if (window.gtag) {
//       window.gtag('event', 'conversion', {
//         send_to: label,
//         event_callback: callback
//       });
//     } else {
//       console.warn('⚠️ gtag not available. Fallback triggered.');
//       callback();
//     }
//   };
  
//   return (
//     <div className="contact-form-overlay">
//       <div className="contact-form-container">
//         <button className="contact-form-close-btn" onClick={() => setShowPopup(false)}>×</button>
//         <h2 className="contact-form-title">Please fill in the details below</h2>
//         <form className="contact-form-form" onSubmit={handleSubmit}>
//           <label>Your Name</label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             className="contact-form-input"
//             required
//           />

//           <label>Your Number</label>
//           <input
//             type="text"
//             name="number"
//             value={formData.number}
//             onChange={handleChange}
//             className="contact-form-input"
//             required
//           />

//           <label>Your Email</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             className="contact-form-input"
//             required
//           />

//           <label>Your Message</label>
//           <textarea
//             name="message"
//             value={formData.message}
//             onChange={handleChange}
//             className="contact-form-textarea"
//             rows="4"
//             required
//           ></textarea>

//           <div className="contact-form-buttons">
//             <button type="submit" className="contact-form-btn">Send</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default PopupContactForm;

import React, { useEffect, useState } from 'react';
import '../Styles/PopupContactForm.css';
import axios from "axios";

import {
  getCampaignId,
  getConversionLabel,
  gtag_report_conversion,
} from './ConversionHandler';

const PopupContactForm = ({ showPopup, setShowPopup }) => {
  const campaignId = getCampaignId();

  const [formData, setFormData] = useState({
    fname: '',
    number: '',
    email: '',
    'lead-message': '',
    secret: 'norg2021' // replace with actual secret
  });

  const getSourceFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('s') || '258';
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [setShowPopup]);

  if (!showPopup) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const label = getConversionLabel('form', campaignId);
    console.log('📨 Popup form submitted - Conversion Label:', label);

    const payload = {
      name: formData.fname,
      email: formData.email,
      number: formData.number,
      'lead-message': formData['lead-message'],
      source: getSourceFromURL(),
      secret: formData.secret
    };

    try {
      const response = await axios.post('https://krushika.org/crm/endpoint.php', payload);
      console.log('Form submitted successfully', response.data);
    } catch (error) {
      console.error('Error submitting form', error);
    }

    const callback = () => {
      console.log('✅ Popup form conversion recorded');
      alert('Thank you! We’ve received your message.');
      setShowPopup(false);
    };

    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: label,
        event_callback: callback
      });
    } else {
      console.warn('⚠️ gtag not available. Fallback triggered.');
      callback();
    }
  };

  return (
    <div className="contact-form-overlay">
      <div className="contact-form-container">
        <button className="contact-form-close-btn" onClick={() => setShowPopup(false)}>×</button>
        <h2 className="contact-form-title">Please fill in the details below</h2>
        <form className="contact-form-form" onSubmit={handleSubmit}>
          <label>Your Name</label>
          <input
            type="text"
            name="fname"
            value={formData.fname}
            onChange={handleChange}
            className="contact-form-input"
            required
          />

          <label>Your Number</label>
          <input
            type="text"
            name="number"
            value={formData.number}
            onChange={handleChange}
            className="contact-form-input"
            required
          />

          <label>Your Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="contact-form-input"
            required
          />

          <label>Your Message</label>
          <textarea
            name="lead-message"
            value={formData['lead-message']}
            onChange={handleChange}
            className="contact-form-textarea"
            rows="4"
            required
          ></textarea>

          <div className="contact-form-buttons">
            <button type="submit" className="contact-form-btn">Send</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PopupContactForm;
